import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import {
  GetDbsSettingsResponseTO,
  UpdateDbsSettingsPayload,
} from 'models/DbsSettings';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { DBS_SETTINGS_URL } from './useFetchDbsSettings';

interface UpdateDbsSettingsArgs {
  agencyUid: string;
  payload: UpdateDbsSettingsPayload;
}

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    GetDbsSettingsResponseTO,
    BaseErrorResponse,
    UpdateDbsSettingsArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const updateDbsSettings = async ({
  agencyUid,
  payload,
}: UpdateDbsSettingsArgs) => {
  const response = await API.patch<GetDbsSettingsResponseTO>(
    DBS_SETTINGS_URL,
    payload,
    { params: { agencyUid } },
  );
  return response.data;
};

const useUpdateDbsSettingsMutation = (
  options: ReactQueryMutationOptions = {},
) => {
  return useAppMutation({
    mutationFn: updateDbsSettings,
    ...options,
  });
};

export default useUpdateDbsSettingsMutation;
